import React, { useEffect } from "react";
import moment from "moment";
import { useSelector} from "react-redux";
import { Badge, CustomDataTable, PopupMenu } from "../../../components";
import { DashboardRow } from "../../../styles/admin/CardBox.styled";
import { getTeamMembersBadge } from "../../../misc/helpers";
import { DetailsButton, Flex } from "../../../styles/admin/DetailsPanel";
import { LoadingBar } from "../../../components/loading_bar/LoadingBar";
import { getAdmins, deleteAdmin, reset } from "../../../features/admin/adminSlice";
import { Routes } from "../../../core/routes/apiRoutes";
import { Link, useNavigate } from "react-router-dom";
import useResource from "../../../core/hooks/useResource";
import { AppRoutes } from "../../../core/routes/routes";

const perPage = 30;

function TeamMembers() {
	const navigate = useNavigate();
	const onChangeStatus = (email) => {
		navigate(AppRoutes.changeMemberStatusUrl+"/"+email);
	};

	const prepareTableData = (response, page) => {
		var rows = [];
		const tempData = response.data;

		for (let i = 0; i < tempData.length; i++) {
			var item = {
				id: i + 1 + page,
				sn: i + 1 + page,
				name: tempData[i].last_name + " " + tempData[i].first_name,
				email: tempData[i].email,
				role: tempData[i].role,
				dateCreated: moment.unix(tempData[i].joined_at).fromNow(),
				status: tempData[i].status,
			};

			rows.push(item);
		}

		return rows;
	};

	const { onPrevPage, onNextPage, page, tableData, ref, isLoading, onDelete, onSearch} =
		useResource({
			selector: useSelector((state) => state.admin),
			perPage: perPage,
			getReducer: getAdmins,
			resetReducer: reset,
			deleteReducer: deleteAdmin,
			renderTableData: prepareTableData,
			routes: {
				getRoute: Routes.getAdminsUrl,
			},
		});

	const actions = [
		{ title: "Change Status", onClick: onChangeStatus },
		{ title: "Delete", onClick: onDelete },
	];

	const columns = [
		{
			field: "sn",
			headerName: "S/N",
			minWidth: 10,
			flex: 1,
		},
		{
			field: "name",
			headerName: "Name",
			minWidth: 100,
			flex: 2,
		},

		{
			field: "email",
			headerName: "Email Address",
			minWidth: 100,
			flex: 2,
		},
		{
			field: "role",
			headerName: "Role",
			minWidth: 100,
			flex: 2,
		},
		{
			field: "dateCreated",
			headerName: "Date Created",
			minWidth: 100,
			flex: 2,
		},
		{
			field: "status",
			headerName: "Status",
			minWidth: 100,
			flex: 2,
			sortable: false,
			renderCell: (params) => {
				const badge = getTeamMembersBadge(params.row.status);
				return <Badge {...badge.badgeType}>{badge.badgeText}</Badge>;
			},
			disableClickEventBubbling: true,
		},
		{
			field: "actions",
			headerName: "",
			minWidth: 100,
			flex: 1,
			sortable: false,
			renderCell: (params) => {
				return <PopupMenu id={params.row.email} options={actions} />;
			},
			disableClickEventBubbling: true,
		},
	];

	useEffect(() => {
		document.title = "Team Members - Greymate Care Admin";
	}, []);

	return (
		<>
			<LoadingBar ref={ref} shadow={true} />
			<Flex justifyContent="space-between" alignItems="center">
				<h1>Team Members</h1>
				<DetailsButton as={Link} to="create" $primary>
					Add Team Members
				</DetailsButton>
			</Flex>

			<DashboardRow>
				<CustomDataTable
					disableSelectionOnClick
					pageSize={perPage}
					pagination="false"
					rowsPerPageOptions={[]}
					loading={isLoading}
					columns={columns}
					rows={tableData}
					hideFooter={true}
					prev={onPrevPage}
					next={onNextPage}
					currentPage={page}
					onSearchChange={onSearch}
				/>
			</DashboardRow>
		</>
	);
}

export default TeamMembers;
